import storefront from "../storefront/index";
import * as queries from "../storefront/queries";
import unwrapNodes from "../unwrapNodes";

const cache = {};

export default function fetchProduct(handle) {
  if (handle in cache) {
    return cache[handle];
  }
  cache[handle] = storefront
    .request({
      query: queries.product,
      variables: {
        handle,
      },
    })
    .then(({ data }) => {
      return unwrapNodes(data.productByHandle);
    });

  return cache[handle];
}
